import { render } from "./SpreadsheetComponent.vue?vue&type=template&id=0a7be0cb"
import script from "./SpreadsheetComponent.vue?vue&type=script&lang=js"
export * from "./SpreadsheetComponent.vue?vue&type=script&lang=js"

import "./SpreadsheetComponent.vue?vue&type=style&index=0&id=0a7be0cb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__